
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eat-drink/[slug]",
      function () {
        return require("private-next-pages/eat-drink/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eat-drink/[slug]"])
      });
    }
  